import React, { useEffect, useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import i18n from '@i18n';
import BetbookPostItem from './BetbookPostItem';
import BetbookPostDetailHeader from './BetbookPostDetailHeader';
import { BetbookContextProvider } from 'nike-ui/src/common/BetbookContext';
import EditorWithComments from '@/betbook/views/EditorWithComments';
import { clearPostDetail, fetchPostById, incrementBetbookPostViewCount } from '@/betbook/handlers';
import { postDetail$ } from '@/betbook/subs';
import { incrementPostViews } from 'nike-ui/src/components/betbook/handlers';

function BetbookPostDetail({ postType, postId }) {
    const { subscribe } = useReframe();
    const post = subscribe(postDetail$);
    const [commentsCount, setCommentsCount] = useState(post?.commentCount || 0);

    useEffect(() => {
        dispatch(fetchPostById(postType, postId));
        incrementPostViews(postType, postId, id => dispatch(incrementBetbookPostViewCount(id)));
        return () => dispatch(clearPostDetail);
    }, [postId, postType]);
    useEffect(() => {
        setCommentsCount(post?.commentCount || 0);
    }, [post]);

    if (!post) {
        return null;
    }
    if (post.error === 'NOT_FOUND') {
        return <EmptyState text={i18n('betbook.detail.notfound')} />;
    }
    return (
        <BetbookContextProvider
            betbookPostId={Number(postId)}
            betbookPostType={postType}
            betbookPostAuthor={post?.author?.contractId}
            betbookBetId={post?.pick?.betId}
            betbookBetSelectionCode={post?.pick?.betSelectionCode}
        >
            <BetbookPostDetailHeader postType={postType} post={post} commentsCount={commentsCount} />
            <div className="betbook-post-wrapper-margin">
                <div className="betbook-post-wrapper">
                    <BetbookPostItem postType={postType} post={post} detail />
                    <EditorWithComments commentsCount={commentsCount} subjectType={postType} subjectId={postId} />
                </div>
            </div>
        </BetbookContextProvider>
    );
}

export default BetbookPostDetail;
